import { GetMacroplanogramInput, useGetMacroplanogramQuery } from '@graphql/generated/graphql';
import { AgileMacroplanogram, AgileMacroplanogramResult } from 'src/components/agile/types/AgileMacroplanogramTypes';
import { parseMacroData } from '@components/agile/utils/FixtureDataUtils';
import { MacroData } from '@components/agile/types/zoneMapType';

const useGetMacroplanogramResults = (input: GetMacroplanogramInput, options?: { enabled?: boolean }) => {
  const { enabled = true } = options ?? {};
  const { ...restInput } = input;

  const { data, isSuccess, isLoading } = useGetMacroplanogramQuery(
    {
      input: {
        ...restInput,
      },
    },
    {
      refetchOnWindowFocus: false,
      enabled,
    },
  );
  const macroplanogramList: AgileMacroplanogram[] | undefined | null = data?.getMacroplanogram.macroplanogram;

  let zoneNameList: MacroData[] = [];
  if (macroplanogramList) {
    zoneNameList = parseMacroData(macroplanogramList);
  }
  return {
    macroplanogramList,
    zoneNameList,
    isSuccess,
    isLoading,
  } as AgileMacroplanogramResult;
};

export default useGetMacroplanogramResults;
